import { buildCartStorageKey } from "./cartStorage";
import { MenuTypeType } from "@/graphql/schema/types";

export const CART_CHANGED_EVENT = "meqr:cart:changed";

export const emitCartChanged = (menuId: number) => {
  window.dispatchEvent(
    new CustomEvent(CART_CHANGED_EVENT, { detail: { menuId } })
  );
};

export const subscribeCartChanges = (menuId: number, onChange: () => void) => {
  const onCustomEvent = (event: Event) => {
    const custom = event as CustomEvent<{ menuId?: number }>;
    if (custom?.detail?.menuId === menuId) onChange();
  };

  const onStorageEvent = (event: StorageEvent) => {
    if (event.key === buildCartStorageKey(menuId)) onChange();
  };

  window.addEventListener(CART_CHANGED_EVENT, onCustomEvent);
  window.addEventListener("storage", onStorageEvent);

  return () => {
    window.removeEventListener(CART_CHANGED_EVENT, onCustomEvent);
    window.removeEventListener("storage", onStorageEvent);
  };
};

export const mapUrlToMenuType: Record<string, MenuTypeType> = {
  delivery: MenuTypeType.Delivery,
  "for-establishment": MenuTypeType.DineIn,
  "self-delivery": MenuTypeType.Pickup,
};

export const getMenuTypeFromUrl = (
  typeMenu?: string
): MenuTypeType | undefined => {
  if (!typeMenu) return undefined;
  return mapUrlToMenuType[typeMenu];
};

export const menuTypeToMenuItemsTypeMap: Record<MenuTypeType, string> = {
  [MenuTypeType.DineIn]: "for-establishment",
  [MenuTypeType.Pickup]: "self-delivery",
  [MenuTypeType.Delivery]: "delivery",
};
